import { Settings as SettingsIcon, Upload, Download } from 'lucide-react'
import { Button } from '../shadcn/button'

export interface HeaderProps {
  onImport?: () => void
  onExport?: () => void
  onSettings?: () => void
}

export function Header({ onImport, onExport, onSettings }: HeaderProps) {
  return (
    <header className="border-b border-border bg-background">
      <div className="container flex items-center justify-between py-5">
        <div className="flex items-center gap-3">
          <div className="bg-primary text-primary-foreground flex h-9 w-9 items-center justify-center rounded-md font-display text-xl">
            §
          </div>
          <div>
            <h1 className="font-display text-2xl leading-none tracking-tight">
              Folha Fiscal
            </h1>
            <p className="text-muted-foreground text-[12px] leading-tight">
              Conversão de rendimentos no exterior · IN SRF 208/2002
            </p>
          </div>
        </div>
        <nav className="flex items-center gap-1">
          <Button variant="ghost" size="sm" onClick={onImport}>
            <Upload />
            Importar
          </Button>
          <Button variant="ghost" size="sm" onClick={onExport}>
            <Download />
            Exportar
          </Button>
          <Button variant="ghost" size="icon" onClick={onSettings} aria-label="Configurações">
            <SettingsIcon />
          </Button>
        </nav>
      </div>
    </header>
  )
}
